export default "/images/Logo-Thick-Black-watches_jewllery-LG.svg?8cc4484a57ee1b6c25d7cf265591d69b";